import React from "react";
import { deleteCookie } from "../../helpers/cookies";
import burgerMenu from "../../assets/burger_menu.svg";

import "./navbar.css";

export default function Navbar() {
  const handleLogOut = () => {
    deleteCookie("user", "/");
    deleteCookie("login_level", "/");
  };

  return (
    <div className="navbar_custom p-3">
      <div className="row align-items-center">
        <div className="col-4 text-left">
          <img
            alt="MakeMyHouseGreen logo"
            src="https://platform.makemyhousegreen.com/images/header/logo.svg"
            className="navbar-logo img img-fluid"
          />
        </div>
        <div className="col-4">BETA</div>
        <div className="col-4 text-right">
          <div className="dropdown">
            <div type="button" data-toggle="dropdown" aria-expanded="false">
              <img
                src={burgerMenu}
                alt="burger menu"
                className="img img-fluid"
              />
            </div>
            <div className="custom-dropdown dropdown-menu">
              <a className="dropdown-item" href="/" onClick={handleLogOut}>
                <i className="icon icon-sign-out icon-lg text-green mr-2" />
                <b className="text-white">Log out</b>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
